import React from 'react';

import { Formik } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import CreateForm from './CreateForm';
import useCreateSchema from './useCreateSchema';
import { participantsOptions } from '../Constants';

const CreateContactInformation = ({
  configuration = {},
  contactsInfo,
  setContactsInfo,
  setIsFormValid,
  setParticipants = () => {},
  disableKeyFields = false,
  setBookingPersonRadio,
  isEventFree = false,
  isEventIlias = false
}) => {
  const contactInformationValidationSchema = useCreateSchema(false, isEventFree);

  const onSubmit = (values, { setSubmitting }) => {
    setContactsInfo(values);
    setBookingPersonRadio(values?.isBookingPerson);
    setParticipants((prevParticipants) => {
      const updatedParticipants = [...prevParticipants];
      if (updatedParticipants.length > 0) {
        updatedParticipants[0] = {
          ...updatedParticipants[0],
          ...values,
          isBookingPerson: values?.isBookingPerson === participantsOptions.bookingPerson
        };
      } else {
        updatedParticipants.push({
          ...values,
          id: uuidv4(),
          isBookingPerson: values?.isBookingPerson === participantsOptions.bookingPerson
        });
      }
      return updatedParticipants;
    });

    setSubmitting(false);
  };

  return (
    <>
      <Formik
        validateOnMount
        initialValues={contactsInfo}
        validationSchema={contactInformationValidationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setValues }) => {
          return (
            <>
              <CreateForm
                isEventFree={isEventFree}
                configuration={configuration}
                values={values}
                setIsFormValid={setIsFormValid}
                setValues={setValues}
                disableKeyFields={disableKeyFields}
                isEventIlias={isEventIlias}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};
export default CreateContactInformation;
